// @flow
import React, { Component } from 'react';
import { type CatalogRegistration } from '../../types/CatalogRegistration';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import ShouldLogInContainer from '../../components/ShouldLogIn/ShouldLogInContainer';
import styles from './RegisterLink.module.scss';

type Props = {
    catalogId: number,
    catalogRegistration: CatalogRegistration,
    className: string,
    isCatalogOnly: boolean,
    itemId: ?number,
    openRegisterForAuctionModal: Function,
    registerToBidMessageId: string,
    submitRegisterForCatalog: Function,
};

export default class RegisterLink extends Component<Props> {
    static defaultProps = {
        className: '',
        registerToBidMessageId: 'register_for_auction',
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const {
            catalogId,
            catalogRegistration,
            className,
            isCatalogOnly,
            itemId,
            openRegisterForAuctionModal,
            registerToBidMessageId,
            submitRegisterForCatalog,
        } = this.props;

        const { declined, pending, suspended } = catalogRegistration;

        let registeredMessage;
        if (suspended) {
            registeredMessage = 'account_suspended';
        } else if (declined) {
            registeredMessage = 'registration_declined';
        } else if (isCatalogOnly) {
            registeredMessage = 'request_submitted';
        } else {
            registeredMessage = pending ? 'registration_pending' : 'registration_approved';
        }

        if (catalogRegistration.registered) {
            return (
                <span className={`${styles.registered} ${className}`}>
                    <FormattedMessage id={registeredMessage} />
                </span>
            );
        }

        if (isCatalogOnly) {
            return (
                <ShouldLogInContainer
                    requireLogin
                    requireCompleteProfile
                    runFunction={submitRegisterForCatalog}
                    runFunctionArgument={{ catalogId, itemId }}
                >
                    <span className={`${styles['register-for-auction']} ${className}`}>
                        <FormattedMessage id="request_online_bidding" />
                    </span>
                </ShouldLogInContainer>
            );
        }

        return (
            <ShouldLogInContainer
                requireLogin
                requireCompleteProfile
                runFunction={openRegisterForAuctionModal}
                runFunctionArgument={{ catalogId, itemId }}
            >
                <span className={`${styles['register-for-auction']} ${className}`}>
                    <FormattedMessage id={registerToBidMessageId} />
                </span>
            </ShouldLogInContainer>
        );
    }
}
